import { EPromoType, IPromo } from '../../../../../types/newbuilding/promos';

export function isMortgageButtonAvailable(promoInfo: IPromo) {
  const isPartner = promoInfo.bank?.isPartner || false;

  return isPartner || promoInfo.promoType === EPromoType.CianMortgage;
}
